import { render, staticRenderFns } from "./TheLayoutDrawerList.vue?vue&type=template&id=25f38e9e"
import script from "./TheLayoutDrawerList.vue?vue&type=script&lang=js"
export * from "./TheLayoutDrawerList.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutDrawerList.vue?vue&type=style&index=0&id=25f38e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports